module.exports = __webpack_public_path__ + "static/media/aquaPark_tn.6da6ed82.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Latium/aquaPark_tn.jpg
// module id = 674
// module chunks = 0